export * from './secure-image.pipe';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/image/index.ts